'use client'

import {Loader2} from 'lucide-react'
import {useIntl} from 'react-intl'
import {Button} from '@/components/ui/button'

type LoadMoreButtonProps = {
  onClick: () => void
  loading?: boolean
  label?: string
  loadingLabel?: string
}

export function LoadMoreButton({
  onClick,
  loading = false,
  label,
  loadingLabel,
}: LoadMoreButtonProps) {
  const intl = useIntl()
  const resolvedLabel =
    label ?? intl.formatMessage({id: 'common.loadMore', defaultMessage: 'Load more'})
  const resolvedLoadingLabel =
    loadingLabel ?? intl.formatMessage({id: 'common.loading', defaultMessage: 'Loading…'})

  return (
    <Button
      variant="outline"
      onClick={onClick}
      disabled={loading}
      aria-busy={loading}
      className="min-w-[140px]"
    >
      {loading ? (
        <>
          <Loader2 className="mr-2 size-4 animate-spin" />
          {resolvedLoadingLabel}
        </>
      ) : (
        resolvedLabel
      )}
    </Button>
  )
}
